// Helfer für die Kommentar-Ansicht.

export const getInitials = (vname, nname) =>
    `${vname?.charAt(0) || ""}${nname?.charAt(0) || ""}`.toUpperCase();

export const formatTime = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);

    if (diffMins < 1) return "Gerade eben";
    if (diffMins < 60) return `vor ${diffMins} Min`;
    if (diffMins < 1440) return `vor ${Math.floor(diffMins / 60)} Std`;
    return date.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit" });
};
